import React from 'react';
import { createCustomInputClassName } from './customInputStyles';

interface TProps {
  name: string;
  placeholder: string;
  value?: string;
  invalid?: boolean;
  autoFocus?: boolean;
  testId?: string;
  maxLength?: number;
  onChange(event: React.ChangeEvent<HTMLInputElement>): void;
}

export const CustomInputNativeInputComponent = (props: TProps) => {
  const { invalid, testId, ...nativeProps } = props;

  return (
    <input
      {...nativeProps}
      className={createCustomInputClassName('input')}
      data-invalid={invalid}
      data-testid={testId}
    />
  );
};
